export default __webpack_public_path__ + "static/media/019-Siberian Husky.ebd87292.svg";